import React from "react";
import PropTypes from "prop-types";
import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";

const StatusBadge = ({ status, colors }) => {
    const color = status.BadgeColor || colors.find((c) => c.Name === status.BadgeColorName);
    if (!color) return <Badge bg="secondary" className="text-light">None</Badge>;
    const style = {
        backgroundColor: color.BackgroundColor,
        color: color.FontColor,
        border: `1px solid ${color.BackgroundColor}`,
        fontSize: "0.7rem",
        fontWeight: 600,
        padding: "0.35rem 0.55rem",
    };
    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip>
                    {color.Name} • BG {color.BackgroundColor} • Font {color.FontColor}
                </Tooltip>
            }
        >
            <span>
                <span className="badge" style={style}>&nbsp;&nbsp;&nbsp;
                </span>
            </span>
        </OverlayTrigger>
    );
};

StatusBadge.propTypes = {
    status: PropTypes.shape({
        BadgeColor: PropTypes.object,
        BadgeColorName: PropTypes.string,
    }).isRequired,
    colors: PropTypes.arrayOf(
        PropTypes.shape({
            Name: PropTypes.string,
            BackgroundColor: PropTypes.string,
            FontColor: PropTypes.string,
        })
    ).isRequired,
};

export default StatusBadge;
